import React from 'react'
import luminousFacialImg from "./../../../../Images/FacialPage/Luminous Lightening Facial.png";

const LuminousFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={luminousFacialImg} alt="luminousFacialImg" />
    </div>  )
}

export default LuminousFacialImg
